import { render, staticRenderFns } from "./GalaxyNumberInput.vue?vue&type=template&id=1e12e909&scoped=true"
import script from "./GalaxyNumberInput.vue?vue&type=script&lang=js"
export * from "./GalaxyNumberInput.vue?vue&type=script&lang=js"
import style0 from "./GalaxyNumberInput.vue?vue&type=style&index=0&id=1e12e909&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e12e909",
  null
  
)

export default component.exports